module.exports = __webpack_public_path__ + "img/20200507_131903.0f48492c.jpg";